import React, { useCallback, useEffect, useState } from 'react'
import ActionBar from '../../actionBar'
import { bodyContainer, bodyContainerMobile, containerStyle, ddBoxStyle, ddStyle, headerBarStyle, headerBarStyleMobile, headerBoxStyle, headerCellStyle, internalBoxStyle, paperStyle, searchBarStyle, searchBarStyleMobile, TableouterBoxStyle, typographyStyle } from './WORKersDashboard_css'
import { Box, Button, Grid, Typography, TableContainer, TableCell, TableRow, Table, TableHead, Paper, ButtonGroup, Grid2, Chip, Tabs, Tab, CircularProgress } from '@mui/material'
import CustomDropDown from '../../CustomDropDown'
import { genderList, weekDropDown } from '../../../utils/constants'
import CustomTextField from '../../CustomTextField'
import WORKercard from '../WORKerCard/WORKercard'
import { WORKersDashboardLogic } from './WORKersLogic'
import UpdateWORKerDetails from '../UpdateWORKersDetails/updateWORKerDetails'
import { useNavigate } from 'react-router-dom'
import { fetchWORKers, getDistrictWiseWORKerType, getWORKersTopWidgetCategories, getWORKersByCateogary, getUncategorisedWORKersChapterWise } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import PhotoVerfDialog from '../PhotoVerfDialog/PhotoVerfDialog'
import Loader from '../../Loader'
import CustomMenu from '../../CustomMenu'
import WORKersFilters from './WORKersFilters'
import WORKerSettingDialog from './WORKerSettingDialog'
import { amber, green, headingBlue, maroon, mediumGrey, orange, pureWhite, red, textGeen } from '../../../assets/colors'
import AddNewWORKer from './AddNewWORKer'
import _ from "lodash";
import AddNewContributionFields from '../contributionFields/AddNewContributionFields'
import WORKersDashboardTable from './WORKersDashboardTable'
import { button2Style, buttonStyle } from '../../../utils/commonCSS'
import TopCard from '../../TopCard'
import StatsBarCard from '../../StatsBar/StatsBarCard'
import { Group } from '@mui/icons-material'
import HBChart from '../../CustomHorizontalBarChart/HBChart'
import ExcelDownloadButton from './WORKersDownloadButton'
import WORKersCategoryPieChart from './WORKersCategoryPieChart'
import UncategorisedWORKersTable from './UncategorisedWORKersTable'

const WORKersDashboard = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768)
  //   const {WORKersData, isLoader, refetch, updateWORKerDetailsDialogStatus, setUpdateWORKerDetailsDialogStatus} = WORKersDashboardLogic();
  const [selectedWORKerData, setSelectedWORKerData] = useState({})
  const [WORKerSettingDialogStatus, setWORKerSettingDialogStatus] = useState(false)
  const [WORKersData, setWORKersData] = useState([])
  const [isLoader, setIsLoader] = useState(false)
  const [photoVerDialogStatus, setPhotoVerDialogStatus] = useState(false)
  const [tableLoader, setTableLoader] = useState(false)
  const [statsLoader, setStatsLoader] = useState(false)
  const [chartLoader, setChartLoader] = useState(false)

  const [searchText, setSearchText] = useState('')

  const [maleFilter, setMaleFilter] = useState(true)
  const [femaleFilter, setFemaleFilter] = useState(true)
  const [oblAllFilter, setOblAllFilter] = useState(true)
  const [oblSHFilter, setOblSHFilter] = useState(true)
  const [oblDHFilter, setOblDHFilter] = useState(true)
  const [oblWORKerFilter, setOblWORkerFilter] = useState(true)
  const [mCardGFilter, setMCardGFilter] = useState(true)
  const [mCardNGFilter, setMCardNGFilter] = useState(true)
  const [refreshApi, setRefreshApi] = useState(false)

  const [addNewWORKerDialogStatus, setAddNewWORKerDialogStatus] = useState(false)
  const [addContrAreaDialogStatus, setAddContrAreaDialogStatus] = useState(false)
  const [viewType, setViewType] = useState("card");
  const [openDialog, setOpenDialog] = useState(false);

  const [statsBarData, setStatsBarData] = useState([])
  const [selectedStatsTile, setSelectedStatsTile] = useState('total')
  const [chartData, setChartData] = useState({})
  const [chartWORKerCategory, setChartWORKerCategory] = useState('unCategorised')
  const [rightCardView, setRightCardView] = useState((localStorage.getItem('designation') === 'admin' || localStorage.getItem('isStateHead') === 'true') ? 'chart' : 'table')
  const [chartPage, setChartPage] = useState(1)
  const [refreshChart, setRefreshChart] = useState(false)
  const [chartFilterDistrict, setChartFilterDistrict] = useState(null)
  const [chartFilterState, setChartFilterState] = useState(null)
  const [chartFilterGender, setChartFilterGender] = useState(null)
  const [categoryCountData, setCategoryCountData] = useState(null)
  const [categoryLoader, setCategoryLoader] = useState(false)
  const [refreshCategoryData, setRefreshCategoryData] = useState(false)

  const navigate = useNavigate()

  const updateAddWORKerDialogStatus = ((value, refresh = false) => {
    setAddNewWORKerDialogStatus(value)
    if (refresh) {
      setRefreshApi(!refreshApi)
    }
  })

  const updateAddContrAreaStatus = ((value, refresh = false) => {
    setAddContrAreaDialogStatus(value)
    // if(refresh){
    //   setRefreshApi(!refreshApi)
    // }
  })

  const updateMaleFilter = ((value) => {
    setMaleFilter(value)
  })

  const updateFemaleFilter = ((value) => {
    setFemaleFilter(value)
  })

  const updateOblAllFilter = ((value) => {
    setOblAllFilter(value)
    if (value) {
      setOblSHFilter(true)
      setOblDHFilter(true)
      setOblWORkerFilter(true)
    }
  })

  const updateOblSHFilter = ((value) => {
    setOblSHFilter(value)
    if (!value) {
      setOblAllFilter(false)
    } else {
      if (oblDHFilter && oblWORKerFilter) {
        setOblAllFilter(true)
      }
    }
  })

  const updateOblDHFilter = ((value) => {
    setOblDHFilter(value)
    if (!value) {
      setOblAllFilter(false)
    } else {
      if (oblSHFilter && oblWORKerFilter) {
        setOblAllFilter(true)
      }
    }
  })

  const updateOblWORKerFilter = ((value) => {
    setOblWORkerFilter(value)
    if (!value) {
      setOblAllFilter(false)
    } else {
      if (oblDHFilter && oblSHFilter) {
        setOblAllFilter(true)
      }
    }
  })

  const updateRefreshApi = () => {
    setRefreshApi(!refreshApi)
  }

  const updateMCardGFilter = ((value) => {
    setMCardGFilter(value)
  })

  const updateMCardNGFilter = ((value) => {
    setMCardNGFilter(value)
  })

  const updateSearch = (text) => {
    setSearchText(text);
    debouncedApiCall(text)
  }

  const debouncedApiCall = useCallback(
    _.debounce((text) => {
      setRefreshApi(prev => !prev)
    }, 500),
    []
  )

  const handleNameClick = (worker) => {
    setSelectedWORKerData(worker);
    setWORKerSettingDialogStatus(true);
  };

  const updateStatsTile = (value) => {
    setSelectedStatsTile(() => value)
    setRefreshApi(() => !refreshApi)
    setRefreshChart(!refreshChart)
  }

  const updateChartPage = (value) => {
    setChartPage(value)
    setRefreshChart(!refreshChart)
  }

  const handleChartCategoryChange = (event, newCategory) => {
    if (newCategory) {
      setChartWORKerCategory(newCategory)
      setChartPage(1)
    }
  }

  const handleChartClick = (value) => {
    if (!value) return
    if (typeof value === 'string' && value.includes('-')) {
      const [district, state, gender] = value.split(/\s*-\s*/).map(s => s.replace(/\s+/g, ' ').trim());
      setChartFilterDistrict(district);
      setChartFilterState(state)
      setChartFilterGender(gender);
    } else {
      const chapterName = typeof value === 'string' ? value.trim() : String(value);
      if (chartFilterState === chapterName) {
        setChartFilterState(null)
      } else {
        setChartFilterState(chapterName)
      }
    }
    setRefreshApi(prev => !prev);
    setRefreshChart(prev => !prev);
  }

  const clearChartFilter = () => {
    setChartFilterDistrict(null);
    setChartFilterState(null);
    setChartFilterGender(null);
    setRefreshApi(prev => !prev);
    setRefreshChart(prev => !prev);
  }

  useEffect(() => {
    try {
      setTableLoader(true)

      let obligationArray = []

      if (!oblAllFilter) {
        if (oblSHFilter || oblDHFilter || oblWORKerFilter) {
          if (oblSHFilter) {
            obligationArray.push('stateHead')
          }
          if (oblDHFilter) {
            obligationArray.push('districtHead')
          }
          if (oblWORKerFilter) {
            obligationArray.push('WORKer')
          }
        }
      }

      let options = {
        url: fetchWORKers,
        method: 'GET',
        params: {
          maleFilter: maleFilter,
          femaleFilter: femaleFilter,
          obligation: obligationArray,
          mCardGFilter: mCardGFilter,
          mCardNGFilter: mCardNGFilter,
          searchText: searchText,
          statTileValue: selectedStatsTile,
          district: chartFilterDistrict,
          state: chartFilterState,
          gender: chartFilterGender
        },

        headers: {
          Authorization: localStorage.getItem("token")
            ? `Bearer ${localStorage.getItem("token")}`
            : null,
        },
      }

      HttpService(options).then(response => {
        setTableLoader(false)
        setWORKersData(response?.data?.data)
      }).catch(err => {
        console.log("Error in fetching WORKers Details:", err)
        setTableLoader(false)
        if (err?.status === 403) {
          localStorage.clear()
          setIsLoader(false)
          navigate('/Login')
        } else {
          setIsLoader(false)
          // setApiError('Error in Adding tasks. Please Contact Support.')
        }
      })
    } catch (err) {
      console.log("Error in fetching WORKers Details:", err)
      setTableLoader(false)
      if (err?.status === 403) {
        localStorage.clear()
        setIsLoader(false)
        navigate('/Login')
      } else {
        // setIsLoader(false)
        // setApiError('Error in Adding tasks. Please Contact Support.')
      }
    }
  }, [refreshApi])

  useEffect(() => {
    setStatsLoader(() => true)
    let options = {
      url: getWORKersTopWidgetCategories,
      method: 'GET',
      params: {
        district: chartFilterDistrict,
        state: chartFilterState,
        gender: chartFilterGender
      },
      headers: {
        Authorization: localStorage.getItem("token")
          ? `Bearer ${localStorage.getItem("token")}`
          : null,
      }
    }
    HttpService(options).then(response => {
      setStatsBarData(() => response?.data?.data)
      setStatsLoader(false)
    }).catch(err => {
      console.log("Error in fetching WORKers stats Details:", err)
      setStatsLoader(false)
      if (err?.status === 403) {
        localStorage.clear()
        setIsLoader(false)
        navigate('/Login')
      } else {
        setIsLoader(false)
        // setApiError('Error in Adding tasks. Please Contact Support.')
      }
    })
  }, [refreshApi, chartFilterDistrict])

  // useEffect(() => {
  //   if (localStorage.getItem('designation') === 'admin' || localStorage.getItem('isStateHead') === 'true') {
  //     setChartLoader(() => true)
  //     let options = {
  //       url: getUncategorisedWORKersChapterWise,
  //       method: 'GET',
  //       params: {
  //         page: chartPage,
  //         offset: 10,
  //         WORKerCategory: chartWORKerCategory,
  //         chapter: chartFilterState || undefined,
  //         district: chartFilterDistrict || undefined,
  //         searchText: searchText || undefined
  //       },
  //       headers: {
  //         Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
  //       }
  //     }
  //     HttpService(options).then((resp) => {
  //       const rawData = resp?.data?.data
  //       const list = Array.isArray(rawData) ? rawData : (rawData?.data || [])

  //       const formattedList = list.map((item) => {
  //         const count =
  //           item.chapterTotalUncategorised !== undefined
  //             ? item.chapterTotalUncategorised
  //             : (item.totalUncategorisedCount !== undefined ? item.totalUncategorisedCount : 0)

  //         let color = headingBlue
  //         if (chartWORKerCategory === 'committed') {
  //           color = '#2e7d32'
  //         } else if (chartWORKerCategory === 'unCommitted') {
  //           color = '#ed683c'
  //         }

  //         return {
  //           ...item,
  //           count: count,
  //           totalLeads: count,
  //           color: color
  //         }
  //       })

  //       if (Array.isArray(rawData)) {
  //         setChartData({
  //           totalRecords: rawData.length,
  //           totalPages: Math.ceil(rawData.length / 10) || 1,
  //           page: chartPage,
  //           offset: 10,
  //           data: formattedList
  //         })
  //       } else if (rawData && typeof rawData === 'object') {
  //         setChartData({
  //           ...rawData,
  //           data: formattedList
  //         })
  //       } else {
  //         setChartData({
  //           totalRecords: 0,
  //           totalPages: 1,
  //           page: 1,
  //           offset: 10,
  //           data: []
  //         })
  //       }
  //       setChartLoader(false)
  //     }).catch(err => {
  //       console.log("Error in fetching Chapter wise chart data:", err)
  //       setChartLoader(false)
  //       if (err?.status === 403) {
  //         localStorage.clear()
  //         setIsLoader(false)
  //         navigate('/Login')
  //       } else {
  //         setIsLoader(false)
  //         // setApiError('Error in Adding tasks. Please Contact Support.')
  //       }
  //     })
  //   }
  // }, [refreshChart, chartFilterDistrict, chartFilterState, chartWORKerCategory, chartPage])

  useEffect(() => {
    setCategoryLoader(true)
    let options = {
      url: getWORKersByCateogary,
      method: 'GET',
      params: {
        district: chartFilterDistrict,
        chapter: chartFilterState,
        gender: chartFilterGender
      },
      headers: {
        Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
      }
    }
    HttpService(options).then((resp) => {
      setCategoryCountData(resp?.data?.data || null)
      setCategoryLoader(false)
    }).catch(err => {
      console.log("Error in fetching WORKers by category counts:", err)
      setCategoryLoader(false)
      if (err?.status === 403) {
        localStorage.clear()
        navigate('/Login')
      }
    })
  }, [refreshApi, refreshChart, refreshCategoryData, chartFilterDistrict, chartFilterState, chartFilterGender])

  return (
    <>
      {(tableLoader || statsLoader || chartLoader) && <Loader></Loader>}
      <ActionBar dashBoard='WORKers'
        updatePhotoVerDialogStatus={() => { setPhotoVerDialogStatus(!photoVerDialogStatus) }}
        updateAddNewWORKerDialogStatus={() => { setAddNewWORKerDialogStatus(true) }}
        updateAddContrAreaStatus={() => { setAddContrAreaDialogStatus(!addContrAreaDialogStatus) }}
      ></ActionBar>
      <Box sx={containerStyle}>
        <Box style={{ ...headerBarStyle, }}>
          {localStorage.getItem('designation') === 'admin' &&
            <Box style={ddBoxStyle}>

              <WORKersFilters
                maleFilter={maleFilter}
                updateMaleFilter={updateMaleFilter}
                femaleFilter={femaleFilter}
                updateFemaleFilter={updateFemaleFilter}
                oblAllFilter={oblAllFilter}
                updateOblAllFilter={updateOblAllFilter}
                oblSHFilter={oblSHFilter}
                updateOblSHFilter={updateOblSHFilter}
                oblDHFilter={oblDHFilter}
                updateOblDHFilter={updateOblDHFilter}
                oblWORKerFilter={oblWORKerFilter}
                updateOblWORKerFilter={updateOblWORKerFilter}
                mCardGFilter={mCardGFilter}
                updateMCardGFilter={updateMCardGFilter}
                mCardNGFilter={mCardNGFilter}
                updateMCardNGFilter={updateMCardNGFilter}
                updateRefreshApi={updateRefreshApi}
              ></WORKersFilters>
              {/* <CustomDropDown width="10rem" regular={true} list={genderList}></CustomDropDown>
                <Typography style={{color: 'white'}}>{"s"}</Typography>
                <CustomDropDown width="10rem" regular={true} list={genderList}></CustomDropDown> */}


            </Box>}

          <Box style={isMobile ? searchBarStyleMobile : searchBarStyle}>
            <CustomTextField placeHolder='Enter Text To Search'
              value={searchText}
              setFunc={updateSearch}
              regular={true}></CustomTextField>
          </Box>

          <Box
            sx={{ ...ddBoxStyle, justifyContent: 'flex-end', width: '95%', marginLeft: "10px" }}
          >
            <ExcelDownloadButton
              data={WORKersData}
              fileName="WORKers.xlsx"
              buttonText="Download"
            />
          </Box>

          {/* <Box sx={{...ddBoxStyle, justifyContent: 'flex-end', width: '65%'}}>
              <ButtonGroup
                variant="outlined"
                sx={{ borderRadius: "8px", overflow: "hidden",}}
              >
                <Button
                  onClick={() => setViewType("card")}
                  style={viewType === 'card' ?  {...buttonStyle, marginRight: '0rem', borderRadius: '0.5rem 0rem 0rem 0.5rem'} :  {...button2Style, borderRadius: '0.5rem 0rem 0rem 0.5rem'}}
                >
                  CARD VIEW
                </Button>

              <Button
                onClick={() => setViewType("table")}
                style={viewType === 'table' ?  {...buttonStyle, marginRight: '0rem', borderRadius: '0rem 0.5rem 0.5rem 0rem'} :  {...button2Style, borderRadius: '0rem 0.5rem 0.5rem 0rem'}}
              >
                Table View
              </Button>
            </ButtonGroup>
          </Box> */}
        </Box>
        {(chartFilterDistrict || chartFilterState) && (
          <Box style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem', display: 'flex', alignItems: 'center' }}>
            <Chip
              label={
                chartFilterDistrict
                  ? `${chartFilterDistrict} - ${chartFilterState || ''} - ${chartFilterGender || ''}`
                  : `Chapter: ${chartFilterState}`
              }
              onDelete={clearChartFilter}
              style={{ backgroundColor: headingBlue, color: 'white' }}
              sx={{
                '.MuiChip-deleteIcon': {
                  color: 'white',
                  '&:hover': {
                    color: 'rgba(255, 255, 255, 0.7)',
                  },
                },
              }}
            />
          </Box>
        )}
        <Grid container spacing={1} sx={{ backgroundColor: '#f3f3f3', borderRadius: '0.5rem', mt: '0.3rem', p: '0rem 0.1rem 0.5rem 0.1rem' }}>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Total Members' color={headingBlue}
              data={statsBarData?.find((ele) => ele._id === 'total')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='UnAssigned' color={headingBlue}
              data={statsBarData?.find((ele) => ele._id === 'unAssigned')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Nucleus' color={green}
              data={statsBarData?.find((ele) => ele._id === 'nucleus')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Core' color={'#3949AB'}
              data={statsBarData?.find((ele) => ele._id === 'core')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Active' color={'#1565C0'}
              data={statsBarData?.find((ele) => ele._id === 'active')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Compassionate' color={'#7B1FA2'}
              data={statsBarData?.find((ele) => ele._id === 'compassionate')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Virtually Active' color={orange}
              data={statsBarData?.find((ele) => ele._id === 'virtuallyActive')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
          <Grid item xs={4} sm={1.5}>
            <StatsBarCard Icon={Group} label='Inactive' color={maroon}
              data={statsBarData?.find((ele) => ele._id === 'inActive')}
              selectedTile={selectedStatsTile}
              updateTile={updateStatsTile}
            ></StatsBarCard>
          </Grid>
        </Grid>
        <Box style={{ padding: '1.5rem 0.2rem 0.5rem 0.2rem' }}>
          <Grid container spacing={1.5} alignItems="stretch">
            <Grid
              item
              xs={12}
              md={4.5}
              lg={3.8}
            >
              <Box sx={{
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                border: '1px solid #E0E0E0',
                p: { xs: 1, sm: 1.5 },
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}>
                <WORKersCategoryPieChart
                  data={categoryCountData}
                  loader={categoryLoader}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={7.5} lg={8.2}>
              <Box sx={{
                backgroundColor: '#ffffff',
                borderRadius: '0.5rem',
                border: '1px solid #E0E0E0',
                p: { xs: 1, sm: 1.5 },
                height: '100%',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}>
                <UncategorisedWORKersTable
                  refreshPieChart={() => {
                    setRefreshCategoryData((prev) => !prev)
                    setRefreshChart((prev) => !prev)
                  }}
                  chartFilterDistrict={chartFilterDistrict}
                  chartFilterState={chartFilterState}
                  chartFilterGender={chartFilterGender}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <Box sx={isMobile ? bodyContainerMobile : bodyContainer}>

          {viewType === "card" ? (
            <Grid container spacing={1} sx={{ scrollbarWidth: 'none', msOverflowStyle: 'none', '&::-webkit-scrollbar': { display: 'none' } }}>
              {
                WORKersData?.length > 0 ?
                  WORKersData.map(WORKerData => (
                    // console.log("WORKERS DATA FROM: ", WORKerData)
                    <>
                      <Grid item xs={6} sm={1.71} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                        onClick={() => {
                          setSelectedWORKerData(WORKerData)
                          setWORKerSettingDialogStatus(() => true)
                        }
                        }
                      >
                        <WORKercard data={WORKerData}></WORKercard>
                      </Grid>

                    </>
                  )) :
                  <>
                    {!tableLoader &&
                      <Box style={{ display: 'flex', justifyContent: 'center', width: '95%', color: maroon, padding: '1.5rem' }}>
                        <Typography style={{ textAlign: 'center', fontSize: '1.3rem' }}> No Result Found.</Typography>
                      </Box>
                    }

                  </>
              }


            </Grid>

          ) : (
            <WORKersDashboardTable
              data={WORKersData}
              onNameClick={handleNameClick}
            ></WORKersDashboardTable>
          )}



        </Box>


      </Box>
      <WORKerSettingDialog WORKerSettingDialogStatus={WORKerSettingDialogStatus} setWORKerSettingDialogStatus={() => {
        setWORKerSettingDialogStatus(!WORKerSettingDialogStatus)
        setRefreshApi(!refreshApi)
      }} data={selectedWORKerData}></WORKerSettingDialog>
      <PhotoVerfDialog photoVerDialogStatus={photoVerDialogStatus} updatePhotoVerDialogStatus={() => { setPhotoVerDialogStatus(!photoVerDialogStatus) }}></PhotoVerfDialog>
      <AddNewWORKer dialogStatus={addNewWORKerDialogStatus} updateFunc={updateAddWORKerDialogStatus}></AddNewWORKer>
      <AddNewContributionFields dialogStatus={addContrAreaDialogStatus} updateFunc={updateAddContrAreaStatus}></AddNewContributionFields>
    </>
  )
}

export default WORKersDashboard
